<template>
    <div>
        <div class="h-[170px] sm:h-[150px] md:h-[170px] lg:h-[190px] w-full relative">
            <img src="@/assets/img/home/home-footer.jpg" class="w-full h-full object-cover object-center" alt>
            <div class="h-[170px] sm:h-[150px] md:h-[170px] lg:h-[190px] w-screen px-2 absolute top-0 left-0 bg-white/70 flex align-items-center">
                <div class="md:px-[40px] lg:px-[100px]">
                    <div class="relative h-fit mt-2 mb-3">
                        <div class="w-fit flex align-items-center sm:mb-2 sm:-mt-4 text-prime-color fill-prime-color hover:text-black hover:fill-black cursor-pointer" @click="()=>{this.$router.push({path: '/news'})}">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 sm:w-6 sm:h-6" viewBox="0 0 24 24" style="transform: ;msFilter:;">
                                <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
                            </svg>
                            <h6 class="mb-0 font-semibold text-xl">Tất cả tin tức</h6>
                        </div>
                        <h3 class="sm:ml-1 text-2xl md:text-3xl font-semibold w-fit text-justify header-underline pb-[6px] sm:pb-2">{{ entry.name }}</h3>
                        <span class="sm:ml-1 absolute w-1/3 max-w-[60px] h-[3px] md:h-[4px] bg-blue-600 bottom-0 rounded-r-xl"></span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!loading" class="box-content pt-3 md:px-[40px] lg:px-[100px] relative">
            <div class="flex flex-col mb-3 sm:flex-row justify-between">
                <p class="text-lg mb-0"><b>Danh mục</b>: {{ entry.type }}</p>
                <p class="text-lg mb-0"><b>Ngày đăng</b>: {{ getDateTime(entry.createdAt) }}</p>
            </div>
            <div>
                <p class="text-lg md:text-xl text-justify" v-html="entry.description"></p>
            </div>
            <div>
                <div class="relative h-fit mt-6">
                    <h3 class="text-xl md:text-2xl font-semibold w-fit text-justify header-underline pb-[6px] sm:pb-2">Tin tức cùng chuyên mục</h3>
                    <span class="absolute w-1/3 max-w-[60px] h-[3px] md:h-[4px] bg-blue-600 bottom-0 rounded-r-xl"></span>
                </div>
                <vue-horizontal-list :items="sameTypeNews" :options="options" v-if="sameTypeNews">
                    <template v-slot:nav-next class="bg-transparent">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path></svg>
                        </div>
                    </template>
                    <template v-slot:nav-prev>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg>
                        </div>
                    </template>
                    <template v-slot:default="{ item }">
                        <div class="item">
                            <div class="bg-white w-full h-fit shadow-lg shadow-black relative">
                                <img :src="$addPrefix(item.image)" loading="lazy" class="w-full h-[200px] object-cover object-center cursor-pointer" alt="news-thumbnail" @click="pushNewsDetail(item._id)">
                                <div class="px-[8px] py-3 md:px-3 flex flex-col gap-2">
                                    <h5 class="mb-0 font-semibold cursor-pointer truncate capitalize" @click="pushNewsDetail(item._id)">{{ item.name }}</h5>
                                    <p class="line-clamp-2 w-full mb-0" v-html="item.description"></p>
                                    <div class="flex justify-between">
                                        <p class="mb-0 text-gray-400 font-semibold">{{ getDateTime(item.updatedAt) }}</p>
                                        <p class="mb-0 pr-2 hover:text-prime-color cursor-pointer font-semibold" @click="pushNewsDetail(item._id)">Đọc ngay</p>
                                    </div>
                                </div>
                                <b-badge variant="warning" class="absolute top-3 left-3"><h6 class="mb-0 font-semibold">{{ item.type }}</h6></b-badge>
                            </div>
                        </div>
                    </template>
                </vue-horizontal-list>
            </div>
        </div>
        <Loading v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import VueHorizontalList from 'vue-horizontal-list';
import Loading from '@/components/loading'
export default {
    components: {
        VueHorizontalList, Loading
    },
    data() {
        return {
            entry: {},
            sameTypeNews: [],
            loading: true,
            options: {
                responsive: [
                { end: 576, size: 1 },
                { start: 576, end: 768, size: 2 },
                { start: 768, end: 992, size: 3 },
                { start: 992, end: 1280, size: 4 },
                { size: 5 },
                ],
                list: {
                // 1200 because @media (min-width: 1200px) and therefore I want to switch to windowed mode
                windowed: 1280,
                padding: 24,
                },
                position: {
                start: 1,
                },
                autoplay: { play: true, repeat: true, speed: 3000 },
            },
        }
    },
    methods: {
        ...mapActions('news', ['GetNews', 'GetLatestNewsList']),
        async getEntry() {
            let response = await this.GetNews(this.$route.params.id)
            if (response.data.code == 200) {
                this.entry = response.data.data
                let response2 = await this.GetLatestNewsList(this.entry.type)
                if (response2.data.code == 200) {
                    this.sameTypeNews = response2.data.data
                }
                this.loading = false
            }
        },
        getDateTime(rawData) {
            return rawData.substring(8, 10) + '-' + rawData.substring(5, 7) + '-' + rawData.substring(0, 4)
        },
        pushNewsDetail(id) {
            if (id != this.$route.params.id) {
                this.$router.push({path: '/news/detail/' + id})
            } else {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
        }
    },
    created() {
        this.getEntry()
    },
    watch: {
        '$route.params.id': {
            handler: function() {
                this.getEntry()
            }
        }
    }
}
</script>